import React, { Component } from 'react';
import __ from 'lodash';
import parse from 'html-react-parser';

class TblAsmSekolahDinas extends Component {
    constructor(props) {
        super(props);
        this.state = {             
            dataSekolah: [],
        }
    }

    componentDidMount() {
        if(!__.isEmpty(this.props.data)) {              
            this.setState({ dataSekolah: this.props.data})
        }
    }

    renderMapel(arrayMapel) {
        let element = "";
        arrayMapel.map(mapel => {
            let kes = "Perlu Intervensi Khusus";
            let persen = 0.0;
            mapel.kategories.map(data => {
                element += '<td style="text-align: center">'+ data.jumlah +'</td><td style="text-align: center">'+ data.persen +'</td>';
                if(parseFloat(persen) < parseFloat(data.persen)) {
                    persen = data.persen;
                    kes = data.kategori;
                }

            })
            element += '<td style="text-align: center">'+ kes +'</td>';
        })  
        return element;
    }

    render() {
        return(
            <table className="table-asm" width="100%" border="1">
                <thead>
                    <tr>
                        <th className="text-center" rowSpan="3" style={{width: '5px'}}>No</th>
                        <th className="text-center" rowSpan="3" style={{maxWidth: '30%'}}>Nama Sekolah</th>  
                        <th className="text-center" rowSpan="3" style={{width: '15px'}}>Jumlah Siswa</th>       
                        <th className="text-center" colSpan="9">Literasi</th> 
                        <th className="text-center" colSpan="9">Numerasi</th>                                                                       
                    </tr>
                    <tr>     
                        <th className="text-center" colSpan="2" style={{width: '15px'}}>Mahir</th> 
                        <th className="text-center" colSpan="2" style={{width: '15px'}}>Cakap</th>   
                        <th className="text-center" colSpan="2" style={{width: '15px'}}>Dasar</th>                                   
                        <th className="text-center" colSpan="2" style={{width: '15px'}}>Perlu Intervensi Khusus</th>
                        <th className="text-center" rowSpan="2" style={{width: '15px'}}>Kesimpulan</th>

                        <th className="text-center" colSpan="2" style={{width: '15px'}}>Mahir</th> 
                        <th className="text-center" colSpan="2" style={{width: '15px'}}>Cakap</th>   
                        <th className="text-center" colSpan="2" style={{width: '15px'}}>Dasar</th>                                   
                        <th className="text-center" colSpan="2" style={{width: '15px'}}>Perlu Intervensi Khusus</th>
                        <th className="text-center" rowSpan="2" style={{width: '15px'}}>Kesimpulan</th>
                    </tr>  
                    <tr>
                        <th className="text-center" >Jumsis</th> 
                        <th className="text-center">%</th>
                        <th className="text-center">Jumsis</th> 
                        <th className="text-center">%</th>
                        <th className="text-center">Jumsis</th> 
                        <th className="text-center">%</th>
                        <th className="text-center">Jumsis</th> 
                        <th className="text-center">%</th> 

                        <th className="text-center">Jumsis</th> 
                        <th className="text-center">%</th>
                        <th className="text-center">Jumsis</th> 
                        <th className="text-center">%</th>
                        <th className="text-center">Jumsis</th> 
                        <th className="text-center">%</th>
                        <th className="text-center">Jumsis</th> 
                        <th className="text-center">%</th> 
                        
                    </tr>                                      
                </thead> 
                <tbody>
                    {this.state.dataSekolah.map((data,i) => 
                    <tr key={i}>
                        <td className="text-center">{i+1}</td>
                        <td>{data.namaSekolah}</td>
                        <td className="text-center">{data.jumlahSiswa}</td>   
                        {parse(this.renderMapel(data.data))}
                    </tr>                    
                    )} 
                </tbody>
                    
            </table>
        )
    }  

}

export default TblAsmSekolahDinas;
